import * as React from 'react'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'
import { Props } from './type'
export const SearchIcon = (props: Props) => (
  <Svg viewBox='0 0 20 20' fill='none' {...props}>
    <G clipPath='url(#clip0_4808_1593)'>
      <Path
        d='M8.84236 15.684C10.3605 15.6837 11.8349 15.1755 13.0307 14.2403L16.7906 18L18 16.7907L14.2401 13.031C15.1758 11.8351 15.6844 10.3604 15.6847 8.84199C15.6847 5.06949 12.6151 2 8.84236 2C5.06965 2 2 5.06949 2 8.84199C2 12.6145 5.06965 15.684 8.84236 15.684ZM8.84236 3.7105C11.6725 3.7105 13.9741 6.01197 13.9741 8.84199C13.9741 11.672 11.6725 13.9735 8.84236 13.9735C6.01219 13.9735 3.71059 11.672 3.71059 8.84199C3.71059 6.01197 6.01219 3.7105 8.84236 3.7105Z'
        fill='#ABA7AF'
      />
      <Path
        d='M10.05 7.63279C10.3742 7.95778 10.5529 8.38712 10.5529 8.84211H12.2635C12.2643 8.39262 12.1759 7.94743 12.0036 7.53228C11.8312 7.11714 11.5783 6.74027 11.2594 6.42347C9.9645 5.13033 7.71935 5.13033 6.42529 6.42347L7.63297 7.6345C8.28299 6.98622 9.40343 6.98793 10.05 7.63279Z'
        fill='#ABA7AF'
      />
    </G>
    <Defs>
      <ClipPath id='clip0_4808_1593'>
        <Rect width={20} height={20} fill='white' />
      </ClipPath>
    </Defs>
  </Svg>
)
